import axios from '@axios'

export default {
  getDocumentTypes(page, field) {
    return axios.post(`platform/doctypes/list?page=${page}`, field)
  },

}
